import { render, staticRenderFns } from "./PreferencesAccountPricing.vue?vue&type=template&id=1f868b0e"
import script from "./PreferencesAccountPricing.vue?vue&type=script&lang=js"
export * from "./PreferencesAccountPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports